import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {userRegister} from "../../services/userRegister";
import {langRegister} from "../../services/langRegister";
import queryString from 'query-string';
import {marketRegister} from "../../services/marketRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class LoginPin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: false,
            email: "",
            password: "",
            user_type: null,
            market: null
        };
    };

    componentWillMount(){
        window.scrollTo(0, 0);
        //document.addEventListener("keydown", this._handleKeyDown.bind(this));
        this._checkToken();
    }

    componentWillUnmount() {
        //document.removeEventListener("keydown", this._handleKeyDown.bind(this));
    }

    _handleKeyDown(event){
        var ENTER_KEY = 13;
        switch( event.keyCode ) {
            case ENTER_KEY:
                this._login();
                break;
            default:
                break;
        }
    }

    _checkToken(){
        let token = tokenRegister.get();
        if(token){
            this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/user/campaigns/running");
        }
    }

    _login(){
        this.setState({isLoading: true, error: false});
        let user = {email:this.state.email, password: this.state.password};
        dataRegister.signIn(this.state.market, user).then((response) => {
            if(!response.errors){
                response.email = this.state.email;
                userRegister.set(response);
                let query = queryString.parse(this.props.location.search);
                if(query.from || query.to){
                    this.props.history.push(query.from?query.from:query.to);
                }else{
                    this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/user/campaigns/running");
                }
            }else{
                this.setState({isLoading: false, error: response.errors});
            }
        }, (error) => {
            this.setState({isLoading: false, error: true});
        });
    }

    _back(){
        this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/login/" + this.state.email + this.props.location.search);
    }

    _forgot(){
        if(this.state.email){
            this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/forgot-password/" + this.state.email);
        }
    }

    _renderButton(){
        if (!this.state.isLoading) {
            return (this._renderText("item_7"));
        } else {
            return (<BeatLoader size={9} color={'#ffffff'} loading={true}/>);
        }
    }

    _renderInput(){
        if(this.state.user_type === "reseller"){
            return(
                  <span className={Styles.inputPasswordContainer}>
                        <input
                              className={
                                  cx(Styles.inputPassword,
                                        {
                                            [Styles.inputError]: this.state.error,
                                        })
                              }
                              type={"password"}
                              placeholder={this._renderText("item_6")}
                              value={this.state.pin}
                              onChange={(event) => this.setState({password: event.target.value})}
                        />
                      <div onClick={() => this._forgot()} className={Styles.inputPasswordForgot}>
                            {this._renderText("item_5")}
                        </div>
                    </span>
            )
        }else{
            return(
                  <span className={Styles.inputPasswordContainer}>
                        <input
                              className={
                                  cx(Styles.inputPassword,
                                        {
                                            [Styles.inputError]: this.state.error,
                                        })
                              }
                              type={"password"}
                              placeholder={this._renderText("item_4")}
                              value={this.state.password}
                              onChange={(event) => this.setState({password: event.target.value})}
                        />
                        <div onClick={() => this._forgot()} className={Styles.inputPasswordForgot}>
                            {this._renderText("item_5")}
                        </div>
                    </span>
            )
        }
    }

    _renderText(item) {
        return langRegister.get("login-pin", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne view={"login"} props={this.props}/>
                <div className={Styles.container}>
                    <div className={Styles.title}>
                        {
                            this.state.user_type === "reseller" &&
                            <span>{this._renderText("item_1")}</span>
                        }
                        {
                            this.state.user_type !== "reseller" &&
                            <span>{this._renderText("item_9")}</span>
                        }
                    </div>
                    <div className={Styles.subtitle}>
                        {
                            this.state.user_type === "reseller" &&
                            <span>{this._renderText("item_10")}</span>
                        }
                        {
                            this.state.user_type !== "reseller" &&
                            <span> {this._renderText("item_2")}</span>
                        }
                    </div>
                    {this._renderInput()}
                    <div onClick={() => this._login()} className={Styles.button}>
                        {this._renderButton()}
                    </div>
                    <div onClick={() => this._back()} className={Styles.text}>
                        {this._renderText("item_8")}
                    </div>
                </div>
            </div>
        );
    }
}

export default LoginPin;


// WEBPACK FOOTER //
// ./src/pages/login-pin/component.js